// extracted by mini-css-extract-plugin
export default {"content":"SocietyAdminTheme_content__Xs3QY","realContent":"SocietyAdminTheme_realContent__ldM-D"};